import { render, staticRenderFns } from "./SettingForms.vue?vue&type=template&id=5d614b22&scoped=true&"
import script from "./SettingForms.vue?vue&type=script&lang=js&"
export * from "./SettingForms.vue?vue&type=script&lang=js&"
import style0 from "./SettingForms.vue?vue&type=style&index=0&id=5d614b22&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d614b22",
  null
  
)

export default component.exports